const form = document.querySelector('.gform_wrapper form');

if (form) {
	const gfields = form.querySelectorAll('.gfield');

	if (gfields) {
		gfields.forEach(gfield => {
			const input = gfield.querySelector('input');

			if (input) {
				const label = gfield.querySelector('.gfield_label');
				input.addEventListener('focus', () => label.classList.add('focus'));
				input.addEventListener('blur', () => label.classList.toggle('focus', input.value.length));

				label.classList.toggle('focus', input.value.length)
			}
		});
	}
}

document.addEventListener('wpcf7mailsent', () => {
	location.href = '/thank-you/';
}, false);